import { KoAPI } from "packages";
import { configs } from 'configuration';
const version = configs().API_VERSION;
export const workspaceAPI = {

  getWorkspace() {
    return KoAPI.get(`/api/${version}/workspace`);
  },

  getWorkspaceById(id) {
    return KoAPI.get(`/api/${version}/workspace/${id}`);
  },

  getworkspaceGroups(workspaceId) {
    return KoAPI.get(`/api/${version}/workspace/groups`, { header: { "workspace": workspaceId } });
  },

  deleteGroup(workspaceId, id) {
    return KoAPI.delete(`/api/${version}/workspace/teams/groups/${id}`, { header: { "workspace": workspaceId } });
  },

  createOrUpdateClient(data, id) {
    if (id) {
      return KoAPI.update(`/api/${version}/workspace/${id}`, { data });
    } else {
      return KoAPI.post(`/api/${version}/workspace`, { data });
    }

  },
  getFormData(workspaceId, formId) {
    return KoAPI.get(`/api/${version}/workspace/form/${formId}`, { header: { "workspace": workspaceId } });

  },
  createOrUpdateForm(workspaceId, data, id) {
    if (id && id !== 'create') {
      return KoAPI.update(`/api/${version}/workspace/form/${id}`, {
        data: { ...data }, header: {
          "workspace": workspaceId
        }
      });
    } else {
      return KoAPI.post(`/api/${version}/workspace/form`, {
        data: { ...data }, header: {
          "workspace": workspaceId
        }
      });
    }

  },
  createOrUpdateCompany(data, id) {
    if (id && id !== 'CLI3103B7FE26') {
      return KoAPI.update(`/api/${version}/admin/customer/${id}`, { data });
    } else {
      return KoAPI.post(`/api/${version}/admin/customer`, { data });
    }
  },
  deleteById(id) {
    return KoAPI.delete(`/api/${version}/workspace/${id}`);
  },
  getClients() {
    return KoAPI.get(`/api/${version}/admin/customer`);
  },
  updateWorkflow(data, templateId, workspaceId) {
    return KoAPI.update(`/api/${version}/workspace/workflow/update/${templateId}`, {
      data: { ...data }, header: {
        "workspace": workspaceId
      }
    });
  },

  getRecentTicket(query) {
    return KoAPI.get(`/api/${version}/taskplanner/ticket/recent`, { query: { ...query } });
  },
  updateTeam(data, id) {
    return KoAPI.post(`/api/${version}/workspace/teams/${id}`, { data });
  },
  getAssignees(workspaceId) {
    return KoAPI.get(`/api/${version}/workspace/teams/${workspaceId}`);
  },
  deleteTeamMember(workspaceId, query) {
    return KoAPI.delete(`/api/${version}/workspace/teams/${workspaceId}`, { query: { ...query } });
  },
  getTemplates() {
    return KoAPI.get(`/api/${version}/workspace/workflow/templates`);
  },
  createTemplate(data, id) {
    if (id) {
      return KoAPI.update(`/api/${version}/workspace/workflow/${id}`, { data });
    } else {
      return KoAPI.post(`/api/${version}/workspace/workflow`, { data });
    }
  },
  deleteTemplate(id) {
    return KoAPI.delete(`/api/${version}/workspace/workflow/${id}`);
  },
  getForms(workspaceId) {
    return KoAPI.get(`/api/${version}/workspace/all/forms`, { header: { "workspace": workspaceId } });
  },
  createForm(data, id) {
    if (id) {
      return KoAPI.update(`/api/${version}/workspace/forms/${id}`, { data });
    } else {
      return KoAPI.post(`/api/${version}/workspace/forms`, { data });
    }
  },
  getFromById(workspaceId, id) {
    return KoAPI.get(`/api/${version}/workspace/form/${id}`, { header: { "workspace": workspaceId } });
  },
  deleteForm(id) {
    return KoAPI.delete(`/api/${version}/workspace/forms/${id}`);
  },
  getTasks(workspaceId, query) {
    return KoAPI.get(`/api/${version}/timeline/list`, { header: { "workspace": workspaceId }, query: { ...query } });
  },
  createTask(data, workspaceId, id) {
    if (id) {
      return KoAPI.update(`/api/${version}/timeline/${id}`, { header: { "workspace": workspaceId }, data });
    }
    return KoAPI.post(`/api/${version}/timeline/create`, { header: { "workspace": workspaceId }, data });
  },
  deleteTask(id, workspaceId) {
    return KoAPI.delete(`/api/${version}/timeline/${id}`, { header: { "workspace": workspaceId } });
  },
  createJiraTickets(workspaceId, data){
    return KoAPI.post(`/api/${version}/taskplanner/ticket/syncjira`,{
      header: {
        workspace: workspaceId
      }, data});
  },
  createAsanaTickets(workspaceId,data){
    return KoAPI.post(`/api/${version}/taskplanner/ticket/syncasana`,{
      header: {
        workspace: workspaceId
      }, data});
  },
  createAvazaTickets(workspaceId, data) {
    return KoAPI.post(`/api/${version}/taskplanner/ticket/syncavaza`,{
      header: {
        workspace: workspaceId
      }, data});
  }
};